import React from 'react';
import * as constantClass from '../fileWithConstants';
import { createPagedGridController } from '../../hooks/pagedGridClassAdapter';
import * as mesasService from '../../services/mesas/mesasService';
import {
  buildLookupMesaExamenValue,
  classifyMesasError,
  formatMesaPeriodoConLlamado,
} from '../../services/mesas/mesasDto';
import { displayDate } from '../../services/dates/dateService';
import { LookupModal, LookupSelectButton, LookupActionHeader } from '../common/LookupModal';
import { createLookupSearchHandlers } from '../common/lookupGridSearch';

export class LookupMesaExamen extends React.Component {
  constructor(props) {
    super(props);
    this.searchInputRef = React.createRef();
    this.state = {
      show: true,
      loading: true,
      searchInput: '',
      perPage: 5,
      paginationData: [],
      pageCount: 1,
      forcePage: 0,
      showErrorMessage: false,
      errorMessage: '',
      carreraCod: props.carreraCod,
    };
    this.grid = createPagedGridController({
      fetchPage: (query) => mesasService.listMesasActivasPaged(this.state.carreraCod, query),
      defaultPageSize: 5,
      onChange: (gridState) => this.applyGridState(gridState),
    });
    const searchHandlers = createLookupSearchHandlers(
      this,
      this.grid,
      (error) => this.handleMesasError(error)
    );
    this.handleSearchInputChange = searchHandlers.handleSearchInputChange;
    this.handleSearchSubmit = searchHandlers.handleSearchSubmit;
  }

  handleModal() {
    this.setState({ show: !this.state.show });
    this.props.hideLookup();
  }

  async componentDidMount() {
    const canAccess = await constantClass.canAccess('WWMesaExamen');
    if (canAccess) {
      this.populateData(this.state.carreraCod);
    }
  }

  applyGridState(gridState) {
    this.setState({
      paginationData: gridState.items,
      pageCount: gridState.pageCount,
      searchInput: gridState.search,
      perPage: gridState.pageSize,
      loading: gridState.loading,
      forcePage: gridState.forcePage,
      showErrorMessage: Boolean(gridState.error),
      errorMessage: gridState.error?.message ?? '',
    });
  }

  handlePageClick = (e) => {
    this.grid.handlePageClick(e).catch((error) => this.handleMesasError(error));
  };

  handleItemSelect = (e) => {
    this.props.selectItem(e);
    this.setState({ show: false });
  };

  renderTable(mesas) {
    return (
      <table className="md-lookup__table md-lookup__table--mesas-examen" aria-label="Seleccionar la Mesa de Examen">
        <thead>
          <tr>
            <th scope="col">Materia</th>
            <th scope="col">Carrera</th>
            <th scope="col">Período de examen</th>
            <th scope="col" className="md-lookup__col-fecha-examen">Fecha de examen</th>
            <LookupActionHeader />
          </tr>
        </thead>
        <tbody>
          {mesas.map((mesa) => (
            <tr key={mesa.mesaExamenCod}>
              <td>{mesa.materiaCarreraNombre}</td>
              <td>{mesa.carreraNombre}</td>
              <td>{formatMesaPeriodoConLlamado(mesa)}</td>
              <td className="md-lookup__col-fecha-examen">
                {displayDate(mesa.mesaExamenFechaExamen)}
              </td>
              <LookupSelectButton
                onClick={() => this.handleItemSelect(buildLookupMesaExamenValue(mesa))}
              />
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  render() {
    return (
      <LookupModal
        show={this.state.show}
        onHide={() => this.handleModal()}
        title="Seleccionar la Mesa de Examen"
        dialogClassName="md-lookup__dialog md-lookup__dialog--mesas-examen"
        searchInputRef={this.searchInputRef}
        searchInput={this.state.searchInput}
        searchPlaceholder="Ingrese la materia"
        onSearchInputChange={this.handleSearchInputChange}
        onSearchSubmit={this.handleSearchSubmit}
        loading={this.state.loading}
        errorMessage={this.state.showErrorMessage ? this.state.errorMessage : ''}
        pageCount={this.state.pageCount}
        forcePage={this.state.forcePage}
        onPageChange={this.handlePageClick}
      >
        {this.renderTable(this.state.paginationData)}
      </LookupModal>
    );
  }

  handleMesasError(error) {
    const outcome = classifyMesasError(error);
    if (outcome.type === 'timeout') {
      constantClass.RedirectToLogin();
      return;
    }
    this.setState({
      showErrorMessage: true,
      errorMessage: outcome.message,
      loading: false,
    });
  }

  async populateData(carreraCod) {
    try {
      if (carreraCod != null) {
        this.setState({ carreraCod });
      }
      await this.grid.load();
    } catch (error) {
      this.handleMesasError(error);
    }
  }
}
